import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=3231be94&"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports